import richText from "utilities/richText"

export default function Content({ blok }) {
  return (
    <section className="px-6 pt-8 lg:pb-18">
      <div className="prose mx-auto">{richText(blok.content)}</div>
    </section>
  )
}
